import { BASE_URL } from "../../configuration/apiconfig";
import UserStore from "../../store/UserStore";

export default class OrderService {
  key = localStorage.getItem("apiKey");

  async getOrderHistoryExport(
    startDate = "",
    endDate = "",
    keys = "",
    type = ""
  ) {
    const response = await fetch(
      BASE_URL +
        "order/export-order-history?=" +
        "&type=" +
        type +
        "&start_date=" +
        startDate +
        "&end_date=" +
        endDate,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      }
    );
    return await response.json();
  }
  async getOrderHistory(
    start = 0,
    length = 10,
    start_date = "",
    end_date = ""
  ) {
    const response = await fetch(
      BASE_URL +
        "order/order_history?length=" +
        length +
        "&start=" +
        start +
        "&start_date=" +
        start_date +
        "&end_date=" +
        end_date,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      }
    );
    return await response.json();
  }
  async getOrderdetails(id) {
    const response = await fetch(BASE_URL + `order/order_history/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "api-key": this.key,
        "access-token": UserStore.key,
      },
    });
    return await response.json();
  }

  async getQROrderdetails(id) {
    const response = await fetch(BASE_URL + `order/get-qr/${id}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "api-key": this.key,
        "access-token": UserStore.key,
      },
    });
    return await response.json();
  }

  async getOrderdetailsForLifeStyle(id) {
    const response = await fetch(
      BASE_URL + `order/get-lifestylepoints-order-details/${id}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      }
    );
    return await response.json();
  }

  async getCommissionReport(
    start = 0,
    length = 10,
    type = "",
    start_date,
    end_date
  ) {
    console.log(
      "params in get commission report",
      start,
      length,
      type,
      start_date,
      end_date
    );
    const queryString = `length=${length}&start=${start}&type=${type}&start_date=${start_date}&end_date=${end_date}`;
    const response = await fetch(
      BASE_URL + "ewallet/commission-report?" + queryString,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      }
    );
    return await response.json();
  }
}
